import NotificationModal from '@anm/components/modals/NotificationModal';
import useNotifications, {
  NotificationElement
} from '@anm/hooks/useNotifications';
import { NotificationsWrapper } from '@anm/components/user/YoutubeWhitelist';
import { useCallback, FC } from 'react';
import { useSelector } from 'react-redux';

import { stockSelectors } from '../../../store/modules/stocks';

const Notification: FC<NotificationElement> = ({
  id,
  deleteNotification,
  ...rest
}) => {
  const handleClose = useCallback(() => deleteNotification(id), [id]);

  if (!rest.type) return null;

  return (
    <NotificationModal
      key={id}
      timeout={4000}
      variant="aside"
      onModalClose={handleClose}
      {...rest}
    />
  );
};

const Notifications: FC = () => {
  const youtubeChannelEntity = useSelector(
    stockSelectors.selectYoutubeChannelEntity
  );
  const youtubeDisputeClaimError = useSelector(
    stockSelectors.selectYoutubeDisputeClaimError
  );
  const youtubeDisputeClaimEntity = useSelector(
    stockSelectors.selectYoutubeDisputeClaimEntity
  );

  const { notifications: youtubeChannelNotifications } = useNotifications({
    ...youtubeChannelEntity,
    errorMessage: `The Youtube Channel Id <b>${youtubeChannelEntity.channelId}</b> is not valid`
  });

  const youtubeError = youtubeDisputeClaimError?.message
    ? JSON.parse(JSON.parse(youtubeDisputeClaimError.message)).errors
    : undefined;

  const { notifications: disputeClaimNotifications } = useNotifications({
    ...youtubeDisputeClaimEntity,
    successMessage: 'Dispute claim successfully added',
    errorMessage: youtubeError
  });

  const notifications = [
    ...youtubeChannelNotifications,
    ...disputeClaimNotifications
  ];

  return (
    <NotificationsWrapper>
      {notifications.map((props: NotificationElement) => (
        <Notification key={props.id} {...props} />
      ))}
    </NotificationsWrapper>
  );
};

export default Notifications;
